import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseCreatePublicCompanyLeadGenericDocumentProps {
  publicCompanyLeadId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useCreatePublicCompanyLeadGenericDocument = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseCreatePublicCompanyLeadGenericDocumentProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['createPublicCompanyLeadGenericDocument'],
    mutationFn: (data: { blob_id: string }) => {
      const lead = {
        generic_documents_attachments_attributes: [
          {
            blob_id: data.blob_id,
          },
        ],
      }

      return privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
